import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import React from "react";
import SupportChatLauncherIcon from "./SupportChatLauncherIcon";

type Props = {
  open: boolean;
  ariaLabel: string;
  onClick: () => void;
  preview?: boolean;
  /** Sin pulso/anillo (prod sin Crisp): FAB propio de Wembii, no imitar widget Crisp. */
  solo?: boolean;
};

export default function SupportChatFab({
  open,
  ariaLabel,
  onClick,
  preview = false,
  solo = false,
}: Props) {
  return (
    <button
      type="button"
      className={cn("wsc-fab", {
        "wsc-fab--launcher": !open,
        "wsc-fab--close": open,
        "wsc-fab--preview": preview,
        "wsc-fab--solo": solo && !open,
      })}
      aria-label={ariaLabel}
      aria-hidden={preview || undefined}
      tabIndex={preview ? -1 : undefined}
      onClick={onClick}
    >
      {!open ? (
        <>
          {!solo ? (
            <>
              <span className="wsc-fab__pulse" aria-hidden />
              <span className="wsc-fab__pulse wsc-fab__pulse--delayed" aria-hidden />
            </>
          ) : null}
          <SupportChatLauncherIcon />
        </>
      ) : (
        <FontAwesomeIcon icon={["fas", "times"]} className="wsc-fab__close-icon" />
      )}
    </button>
  );
}
